<template>

  <div>
    <v-dialog/>
    <!--begin::Root-->
    <div class="d-flex flex-column flex-root">
      <!--begin::Page-->
      <div class="page d-flex flex-row flex-column-fluid">
        <!--begin::Aside-->
          <aside-menu/>
        <!--end::Aside-->
        <!--begin::Wrapper-->
        <div style="min-height:100vh;" class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
          <!--begin::Header-->
          <app-header/>
          <!--end::Header-->
          <!--begin::Content-->
          <div class="content d-flex flex-column flex-column-fluid" id="kt_content">

            <!--begin::Toolbar-->
						<div v-if="0" class="toolbar" id="kt_toolbar">
							<!--begin::Container-->
							<div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
								<ol class="breadcrumb text-muted fs-6 fw-semibold">
									<li class="breadcrumb-item "><a href="#" class="">Home</a></li>
									<li class="breadcrumb-item"><a href="#" class="">{{$module}}</a></li>
									<!-- <li class="breadcrumb-item active">People</li> -->
								</ol>
							</div>
							<!--end::Container-->
						</div>
						<!--end::Toolbar-->

            <!--begin::Post-->
            <div class="post d-flex flex-column-fluid" id="kt_post">
              <!--begin::Container-->
              <div id="kt_content_container" :class="$store.CLASSES.KT_CONTENT_CONTAINER">
                <div v-if="vcWarned" class="alert alert-warning" role="alert">
                  Application UI has been updated. Please reload your browser.
                </div>
                <div id="blob-downloads">
                  <div v-for="blob in $root.blobList.filter(blob => blob.active)" class="alert alert-primary mb-2" role="alert">
                    Preparing file: {{blob.name}}
                  </div>
                </div>
                <router-view :key="$route.path"></router-view>
              </div>
              <!--end::Container-->
            </div>
            <!--end::Post-->
          </div>
          <!--end::Content-->

          <!--begin::Footer-->
          
          <!--end::Footer-->
        </div>
        <!--end::Wrapper-->
      </div>
      <!--end::Page-->
    </div>
    <!--end::Root-->
    <!--begin::Drawers-->
    <!-- <activities-drawer/> -->
    <!-- <chat-drawer/> -->
    <!--end::Drawers-->
    <!--begin::Scrolltop-->
    <div id="kt_scrolltop" class="scrolltop" data-kt-scrolltop="true">
      <!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->
      <span class="svg-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<rect opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)"
                fill="currentColor"/>
					<path
              d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z"
              fill="currentColor"/>
				</svg>
			</span>
      <!--end::Svg Icon-->
    </div>
    <!--end::Scrolltop-->
    <!--end::Main-->
    <!-- begin::User Panel-->
    <!--<user-panel/>-->
    <!-- end::User Panel-->
    <!--<quick-cart/>-->
  </div>
</template>

<script>
import MobileHeader from "@cc/split/MobileHeader.vue";
import UserPanel from "@cc/split/UserPanel.vue";
import QuickCart from "@cc/split/QuickCart.vue";
import AppHeader from "@cc/split/AppHeader.vue";
import AsideMenu from "@cc/split/AsideMenu.vue";
import Toolbar from "@cc/split/Toolbar.vue";
import AppSubheader from "@cc/split/AppSubheader.vue";
import AppAside from "@cc/split/AppAside.vue";
import ActivitiesDrawer from "@cc/split/ActivitiesDrawer.vue";
import ChatDrawer from "@cc/split/ChatDrawer.vue";
import ProjectSwitcher from "@cc/split/ProjectSwitcher.vue";

import versionCheck from '@mxn/versionCheck'

import PhoneVerified from "@cc/presets/PhoneVerified.vue"

export default {
  components: {AppHeader, AsideMenu, Toolbar, QuickCart, ActivitiesDrawer, ChatDrawer, PhoneVerified},
  mixins: [versionCheck],
  data() {
    return {
      vcWarned: false,
      pressedKeys: new Set(),
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('keyup', this.handleErrorCaptureKeyComboUp)
    window.addEventListener('keydown', this.handleErrorCaptureKeyCombo)

    setTimeout(() => {
      KTDrawer.createInstances();
      KTMenu.createInstances()
      KTToggle.createInstances()
      KTScroll.createInstances();
    }, 600)

    this.initSocket()

    if(this.$user.phone=="" || this.$user.phone == null){
      this.$modal.show(PhoneVerified)

    }

    window.blockUI = new KTBlockUI(document.getElementById('kt_wrapper'), {
      zIndex: 1101,
      message: '<div class="blockui-message"><span class="spinner-border text-primary"></span> Loading...</div>',
    });


    // add scrollbar width to padding to avoid content width shift on modal opening
    function scrollbarWidth() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
      const documentWidth = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - documentWidth);
    }

    const scr = document.createElement('style');
    scr.type = 'text/css';
    scr.innerHTML = `
      .vm--block-scroll {
        padding-right: ${scrollbarWidth()}px;
      }
    `
    document.head.appendChild(scr);

    // console.log("KT_DS_ID_N", window.KTUtilElementDataStoreID)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleErrorCaptureKeyComboUp)
    window.removeEventListener('keydown', this.handleErrorCaptureKeyCombo)
  },
  methods: {
    handleErrorCaptureKeyComboUp(e){
      this.pressedKeys.delete(e.key.toLowerCase())
    },
    handleErrorCaptureKeyCombo(e) {
      this.pressedKeys.add(e.key.toLowerCase())

      if (e.ctrlKey && e.altKey && this.pressedKeys.has('r')) {
        e.preventDefault()
        console.log('BUG_REPORT::CTRL_ALT_R')
        this.onCtrlER()
      }
    },
    onCtrlER() {
      this.$root.openBugReportModal()
    },
    initSocket() {
      const ws = new WebSocket(`${API_HOST}/ws/system/`);
      ws.onopen = function (e) {
          ws.send(JSON.stringify({"message": 'Sending message to server'}));
      };
      ws.onmessage = (e) => {
          const data = JSON.parse(e.data);
          console.log(data)
          this.$root.$emit('ws_message', data)
          // if (data.type === 'action') {
          //     $('.client-form').addClass('gone');
          //     $('.ws-progress').removeClass('gone');
          // }
          // if (data.message) {
          //     $('.ws-progress').append(`<p>${data.message}</p>`)
          //     if (data.progress) {
          //         $(".progress-bar").animate({
          //             width: `${data.progress}%`
          //         }, 2500);
          //     }
          // }
      };
      ws.onclose = function (e) {
          console.error('Chat socket closed');
      };
    },
  }
}
</script>